// @flow
import React from 'react'
import './styles.scss'

export function Protagonist ({
  images,
  name,
  filename,
  isWide,
  role,
  description
}: {
  images: { srcSet: string, sources: { [string]: string } },
  name: string,
  filename: string,
  isWide: boolean,
  role: string,
  description: string
}) {

  let url = "https://interaktiv.tagesanzeiger.ch/2019/geldwaescherei-quiz/imgsDocuments/" + filename

  return (
    <a href={url}>
      <figure className={isWide ? 'ui block protagonist image document wide' : 'ui block protagonist image document'}>
        <img
          className={isWide ? 'document wide' : 'document'}
          srcSet={images.srcSet}
          src={images.sources['432w']}
          sizes='(max-width: 599px): 50vw, 216px'
        />
        <figcaption>
          <strong className='title'>{name}</strong> <br />
          <span>{description}</span>
        </figcaption>
      </figure>
    </a>

  )
}
